export const OrganizationType = {
  SYSTEM: "SYSTEM",
  PARTNER: "PARTNER",
  NORMAL: "NORMAL",
  STOCK: "STOCK",
} as const;

export type OrganizationTypeValue =
  (typeof OrganizationType)[keyof typeof OrganizationType];

export default OrganizationType;
